import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { Formik, Field } from "formik";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import HousingService from "../../../Services/HousingService";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import * as Yup from "yup";
import { AiOutlineSearch } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { store } from "../../../App";
import { ExportToExcelButton, generatePDF, GetDetails, LabelHeader, ModuleHeader } from "../../utils/commonFunctions";

function GeneratedMonthlyPayBill() {
  const [EmpTypeList, setEmpTypeList] = useState();
  const [monthlist, setmonthlist] = useState();
  const [yearlist, setyearlist] = useState();
  const [Show, setShow] = useState(false);
  const [empPay, setEmpPay] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [Onetwofive, setOnetwofive] = useState(false);
  const [Three, setThree] = useState(false);
  const [Four, setFour] = useState(false);


  const filteredData = searchQuery.length > 0 ? empPay?.filter((data) => {
    return (
      data && Object.keys(data).some((key) => {
        const value = data[key];
        return (
          value !== null && value.toString().toLowerCase().includes(searchQuery.toLowerCase()));
      }));
  }) : empPay;

  const handleSearchReport = event => { setSearchQuery(event.target.value) }

  React.useEffect(() => {
    HousingService.fetchEmptypeList().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.emptype_id}>
              {item.emptype_name}
            </option>
          );
        });
        setEmpTypeList(options);
      }
    });
    HousingService.fetchMonthList().then((res) => {
      if (res.data) {
        setMonthData(res.data);
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.month_id}>
              {item.month_name}
            </option>
          );
        });
        setmonthlist(options);
      }
    });
    HousingService.fetchYearList().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.year}>
              {item.year}
            </option>
          );
        });
        setyearlist(options);
      }
    });
  }, []);
  const handlePdf = (emp_id, payment_type, year, confirm_month) => {
    const values = {
      emp_id: emp_id,
      payment_type: payment_type,
      year: year,
      confirm_month: confirm_month
    };
    HousingService.emp_pay_particulars_pdf(values).then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );

      let tab = window.open();

      tab.location.href = url;
    });
  };
  const [yearName, setyearName] = useState([]);
  const [monthname, setmonthname] = useState([]);
  const [displayPaymentType, setdisplayPaymentType] = useState();
  const [monthData, setMonthData] = useState([]);
  const distuser = localStorage.getItem("username");


  return (
    <>
      <NavigationServicesHeader />
      <Formik
        initialValues={{
          emp_type: "",
          year: "",
          confirm_month: "",
          payment_type: ""
        }}
        onSubmit={(values) => {
          let yearValue = values.year;
          setyearName(yearValue);
          let monthvalue = monthData
            .filter((item) => item.month_id === values.confirm_month)
            .map((item) => item.month_name);
          setmonthname(monthvalue);

          if (values.payment_type == "reg") {
            setdisplayPaymentType("REGULAR");
          } else {
            setdisplayPaymentType("SUPPLEMENTRY");
          }
          store.dispatch({ type: "SHOW_SPINNER" });
          HousingService.GetMonthlyPayBillDetails(values).then((response) => {
            setEmpPay(response.data);

            if (
              values.emp_type === "1" ||
              values.emp_type === "2" ||
              values.emp_type === "5"
            ) {
              setThree(false);
              setFour(false);
              setOnetwofive(true);
            } else if (values.emp_type === "3") {
              setFour(false);
              setOnetwofive(false);
              setThree(true);
            } else if (values.emp_type === "4") {
              setOnetwofive(false);
              setThree(false);
              setFour(true);
            }
            setShow(true);
            store.dispatch({ type: "HIDE_SPINNER" });
          });
        }}
        validationSchema={Yup.object({
          emp_type: Yup.string().required(),
          year: Yup.string().required(),
          confirm_month: Yup.string().required(),
          payment_type: Yup.string().required()
        })}
      >
        {({ errors, values, touched, setFieldValue, handleSubmit, }) => (
          <Form onSubmit={handleSubmit}>
            <ModuleHeader title="Generated Monthly Pay Bill" />
            <OFMSUI.Container className="outer-page-content-container " fluid style={{ width: "90%" }} >
              <OFMSUI.Row className="p-2 ">
                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" >
                  <LabelHeader title="Employee Type" />
                  <Field component="select" name="emp_type" className={touched.emp_type && errors.emp_type ? "form-control is-invalid" : "form-control"} >
                    <option value="select">Select</option>
                    {EmpTypeList}
                  </Field>
                </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" >
                  <LabelHeader title="Month" />
                  <Field component="select" name="confirm_month" className={touched.confirm_month && errors.confirm_month ? "form-control is-invalid" : "form-control"} >
                    <option value="">Select</option>
                    {monthlist}
                  </Field>
                </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" >
                  <LabelHeader title="Year" />
                  <Field component="select" name="year" className={touched.year && errors.year ? "form-control is-invalid" : "form-control"} >
                    <option value="">---Select---</option>
                    {yearlist}
                  </Field>
                </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" >
                  <LabelHeader title="Payment Type" />
                  <Field
                    component="select"
                    name="payment_type"
                    value={values.payment_type}
                    onChange={(e) => setFieldValue("payment_type", e.target.value)}
                    className={touched.payment_type && errors.payment_type ? "form-control is-invalid" : "form-control"}
                  >
                    <option value="">select</option>
                    <option value="reg">Regular</option>
                    <option value="supp">Supplementary</option>
                  </Field>
                </OFMSUI.Col>
                <GetDetails />
              </OFMSUI.Row>
              {Show && (
                <Form>
                  <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                      <div className="input-group">
                        <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                        <input placeholder="Search" type="text" value={searchQuery} onChange={handleSearchReport} className="form-control form-control-sm" ></input>
                      </div>
                    </OFMSUI.Col>
                    <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                      <ExportToExcelButton tableId="my-table" filename="GeneratedPMonthlyaybill" sheet="tablexls" buttonText="Excel" />
                      <OFMSUI.Col>
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => generatePDF("my-table", "Generated Monthly Pay bill", "GeneratedPMonthlyaybill.pdf", 22)} style={{ float: "right", marginLeft: "3px" }} >
                          PDF
                          <MdOutlinePictureAsPdf />
                        </button>
                      </OFMSUI.Col>
                    </OFMSUI.Col>
                  </OFMSUI.Row>

                  {Onetwofive && (
                    <div style={{ overflow: "auto", height: "800px" }}>
                      <OFMSUI.Table striped bordered hover id="my-table">
                        <thead
                          className="fw-bold"
                          style={{ position: "sticky", top: "0px" }}
                        >
                          <tr>
                            <td colSpan={22} style={{ textAlign: "center" }}>
                              Generated Paybill For {distuser} -{" "}
                              {displayPaymentType} for the {monthname} {yearName}
                            </td>
                          </tr>
                          <tr className="table_countshead">
                            <th>S No.</th>
                            <th>Employee Name</th>
                            <th>Designation</th>
                            <th>
                              BasicPay
                              <br /> Per Pay
                              <br /> Spl.Pay
                              <br /> GP
                            </th>
                            <th>
                              D.A <br /> H.R.A
                              <br /> C.C.A <br /> Spl.All
                            </th>
                            <th>
                              Conve.
                              <br />
                              I.R.
                              <br />
                              Medical
                              <br /> Misc(H.C.)
                            </th>
                            <th>
                              Addl. HRA
                              <br /> SCA
                            </th>
                            <th>Gross Pay</th>
                            <th>
                              APGLI(S) <br />
                              APGLI(L)
                              <br />
                              Rent <br />
                              LIC(S)
                            </th>
                            <th>
                              GPF(S)
                              <br />
                              GPF(L)
                              <br /> GPF(SA)
                              <br /> Con.Ded.
                            </th>
                            <th>
                              GIS
                              <br />
                              Sal.Rec
                              <br />
                              Cell Phone
                              <br />
                              Comp.Adv.
                            </th>
                            <th>
                              HBA
                              <br /> ADHBA
                              <br /> HBA(O) <br />
                              Comp.Adv(I)
                            </th>
                            <th>
                              HBA(I) <br /> ADHBA(I)
                              <br /> CAR(Principal) <br /> CYC(Principal)
                            </th>
                            <th>
                              MCA(Principal) <br />
                              MAR(Principal)
                              <br /> CAR(Interest) <br /> CYC(Interest)
                            </th>
                            <th>
                              MCA(Interest)
                              <br /> MEDI(Principal)
                              <br />
                              FA
                              <br />
                              EA
                            </th>
                            <th>
                              Spl.FA
                              <br />
                              P.Tax <br />
                              MAR(I)
                              <br />
                              I.T
                            </th>
                            <th>
                              HR Arrear
                              <br /> MED(Interest)
                              <br /> Personal Bank(L)
                              <br /> Postal RD
                            </th>
                            <th>
                              RCs. Cont Deductions
                              <br /> CMRF Deductions
                              <br /> FCF Deductions
                              <br />
                              VPF Deductions
                            </th>
                            <th>
                              Salary
                              <br /> Adv.loan
                              <br />
                              HCESA (Interest)loan <br /> Staff Loan
                            </th>
                            <th>
                              Court Loan
                              <br />
                              Other Liabilities
                            </th>
                            <th>Total Deductions</th>
                            <th>Net Pay</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData && filteredData?.length > 0 ? (
                            filteredData.map((key, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td
                                  style={{ width: "140px" }}
                                  onClick={() => {
                                    handlePdf(
                                      key.emp_id,
                                      key.payment_type,
                                      key.year,
                                      key.confirm_month
                                    );
                                  }}
                                >
                                  <Link>{key.name}</Link>
                                </td>
                                <td>{key?.designation}</td>
                                <td>
                                  {key?.basic_pay_earnings}
                                  <br />
                                  {key?.per_pay_earnings}
                                  <br />
                                  {key?.spl_pay_earnings}
                                  <br />
                                  {key?.gp_earnings}
                                </td>
                                <td>
                                  {key?.da_earnings}
                                  <br />
                                  {key?.hr_arrear_loan}
                                  <br />
                                  {key?.ca_earnings}
                                  <br />
                                  {key?.spl_all}
                                </td>
                                <td>
                                  {key?.con_decd_deductions}
                                  <br />
                                  {key?.ir_earnings}
                                  <br />
                                  {key?.medical_earnings}
                                  <br />
                                  {key?.misc_h_c}
                                </td>
                                <td>
                                  {key?.add_hba_loan}
                                  <br />
                                  {key?.sca}
                                </td>
                                <td>
                                  {key?.basic_pay_earnings +
                                    key?.per_pay_earnings +
                                    key?.spl_pay_earnings +
                                    key?.gp_earnings +
                                    key?.da_earnings +
                                    key?.hra_earnings +
                                    key?.cca_earnings +
                                    key?.spl_all}
                                </td>
                                <td>
                                  {key?.apglis_deductions}
                                  <br />
                                  {key?.apglil_deductions}
                                  <br />
                                  {key?.ggg}
                                  <br />
                                  {key?.lic_deductions}
                                </td>
                                <td>
                                  {key?.gpfs_deductions}
                                  <br />
                                  {key?.gpfl_deductions}
                                  <br />
                                  {key?.gpfsa_deductions}
                                  <br />
                                  {key?.con_decd_deductions}
                                </td>
                                <td>
                                  {key?.gis_deductions}
                                  <br />
                                  {key?.sal_rec_deductions}
                                  <br />
                                  {key?.cell_loan}
                                  <br />
                                  {key?.comp_loan}
                                </td>
                                <td>
                                  {key?.hba_loan}
                                  <br />
                                  {key?.add_hba_loan}
                                  <br />
                                  {key?.hbao_loan}
                                  <br />
                                  {key?.comp1_loan}
                                </td>
                                <td>
                                  {key?.hba1_loan}
                                  <br />
                                  {key?.add_hba1_loan}
                                  <br />
                                  {key?.car_a_loan}
                                  <br />
                                  {key?.cyc_a_loan}
                                </td>
                                <td>
                                  {key?.mca_a_loan}
                                  <br />
                                  {key?.mar_a_loan}
                                  <br />
                                  {key?.car_i_loan}
                                  <br />
                                  {key?.cyc_i_loan}
                                </td>
                                <td>
                                  {key?.mca_i_loan}
                                  <br />
                                  {key?.med_a_i_loan}
                                  <br />
                                  {key?.fa_loan}
                                  <br />
                                  {key?.ea_loan}
                                </td>
                                <td>
                                  {key?.con_decd_deductions}
                                  <br />
                                  {key?.pt_deductions}
                                  <br />
                                  {key?.ss}
                                  <br />
                                  {key?.pp}
                                </td>
                                <td>
                                  {key?.hr_arrear_loan}
                                  <br />
                                  {key?.med_a_i_loan}
                                  <br />
                                  {key?.vij_bank_loan}
                                  <br />
                                  {key?.cca_deductions}
                                </td>
                                <td>
                                  {key?.rcs_cont_deductions}
                                  <br />
                                  {key?.cmrf_deductions}
                                  <br />
                                  {key?.fcf_deductions}
                                  <br />
                                  {key?.vpf_deductions} <br />
                                </td>
                                <td>
                                  {key?.sal_adv_loan}
                                  <br />
                                  {key?.hcesa_loan}
                                  <br />
                                  {key?.hcesa_i_loan}
                                  <br />
                                  {key?.staff_pl_loan}
                                </td>
                                <td>
                                  {key?.court_loan}
                                  <br />
                                  {key?.other_deductions}
                                </td>
                                <td>
                                  {key?.pt_deductions + key?.it_deductions}
                                </td>
                                <td>
                                  {key?.basic_pay_earnings +
                                    key?.per_pay_earnings +
                                    key?.spl_pay_earnings +
                                    key?.gp_earnings +
                                    key?.da_earnings +
                                    key?.hra_earnings +
                                    key?.cca_earnings +
                                    key?.spl_all -
                                    (key?.pt_deductions + key?.it_deductions)}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="22" style={{ textAlign: "center" }}>
                                No data found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </OFMSUI.Table>
                    </div>
                  )}
                  {Three && (
                    <div>
                      <OFMSUI.Table striped bordered hover id="my-table">
                        <thead className="fw-bold" style={{ position: "sticky", top: "0px" }}>
                          <tr className="th-row"></tr>
                          <tr className="table_countshead">
                            <th>S No.</th>
                            <th>Employee Name</th>
                            <th>Designation</th>
                            <th>Place of work Location</th>
                            <th> Basic Pay <br /> H.R.A <br /> Medical <br /> C.A <br /> Performance </th>
                            <th> Professional Tax <br /> Other Deductions <br /> Employee EPF <br /> Employer EPF <br /> EPF Contribution </th>
                            <th>Total Earnings</th> <th>Total Deductions</th> <th>Net Salary</th>
                          </tr>
                        </thead>
                        {filteredData && filteredData.length > 0 ? (
                          filteredData.map((key, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td onClick={() => handlePdf(key.emp_id, key.payment_type, key.year, key.confirm_month)}>
                                <Link>{key.name}</Link>
                              </td>
                              <td>{key.designation}</td>
                              <td>{key.work_place || key.os_location}</td>
                              <td>
                                {key.os_basic_pay_earnings} <br />
                                {key.os_hra_earnings} <br />
                                {key.os_medical_earnings} <br />
                                {key.os_ca_earnings} <br />
                                {key.os_performance_earnings}
                              </td>
                              <td>
                                {key.os_prof_tax_deductions} <br />
                                {key.os_other_deductions} <br />
                                {key.os_ees_epf_deductions} <br />
                                {key.os_ers_epf_deductions} <br />
                                {key.os_ec_epf}
                              </td>
                              <td>{key.total_earnings}</td>
                              <td>{key.total_deductions}</td>
                              <td>{key.net_salary}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" style={{ textAlign: "center" }}>
                              No data found
                            </td>
                          </tr>
                        )}

                      </OFMSUI.Table>
                    </div>


                  )}
                  {Four && (
                    <div>
                      <OFMSUI.Table striped bordered hover id="my-table">
                        <thead
                          className="fw-bold"
                          style={{ position: "sticky", top: "0px" }}
                        >
                          <tr className="table_countshead">
                            <th>S No.</th>
                            <th>Employee Name</th>
                            <th>Designation</th>
                            <th>Place of work Location</th>
                            <th>Gross Pay</th>
                            <th> EPF <br /> Postal RD <br /> Professional Tax </th> <th> TDS <br /> FA <br /> EA </th>
                            <th>
                              MA <br />
                              LIC <br />
                              Other Liabilities
                            </th>
                            <th>Total Deductions </th>
                            <th> Net Salary</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData && filteredData?.length > 0 ? (filteredData?.map((key, index) => (
                            <tr key={index}>
                              <td> {index + 1} </td>
                              <td style={{ width: "140px" }} onClick={() => { handlePdf(key.emp_id, key.payment_type, key.year, key.confirm_month); }} > <Link>{key.name}</Link> </td>
                              <td>{key?.designation}</td>
                              <td>{key?.os_location}</td>
                              <td>{key?.nmr_gross_earnings}</td>
                              <td>
                                {key?.os_ees_epf_deductions}
                                <br />
                                {key?.nmr_postalrd_deductions}
                                <br />
                                {key?.os_prof_tax_deductions}
                                <br />
                              </td>
                              <td>
                                {key?.nmr_tds_deductions}
                                <br />
                                {key?.nmr_fa_deductions}
                                <br />
                                {key?.nmr_ea_deductions}
                                <br />
                              </td>
                              <td>
                                {key?.nmr_ma_deductions}
                                <br />
                                {key?.nmr_lic_deductions}
                                <br />
                                {key?.nmr_otherliab_deductions}
                                <br />
                              </td>
                              <td>
                                {key?.os_ees_epf_deductions +
                                  key?.nmr_postalrd_deductions +
                                  key?.os_prof_tax_deductions +
                                  key?.nmr_tds_deductions +
                                  key?.nmr_fa_deductions +
                                  key?.nmr_ea_deductions +
                                  key?.nmr_ma_deductions +
                                  key?.nmr_lic_deductions +
                                  key?.nmr_otherliab_deductions}
                              </td>
                              <td>
                                {key?.nmr_gross_earnings -
                                  (key?.os_ees_epf_deductions +
                                    key?.nmr_postalrd_deductions +
                                    key?.os_prof_tax_deductions +
                                    key?.nmr_tds_deductions +
                                    key?.nmr_fa_deductions +
                                    key?.nmr_ea_deductions +
                                    key?.nmr_ma_deductions +
                                    key?.nmr_lic_deductions +
                                    key?.nmr_otherliab_deductions)}
                              </td>
                            </tr>
                          ))) : (<tr><td className="text-center" colSpan={10}>No data Found </td></tr>)}
                        </tbody>
                      </OFMSUI.Table>
                    </div>
                  )}
                </Form>
              )}
            </OFMSUI.Container>
          </Form>
        )}
      </Formik>
    </>
  );
}
export default GeneratedMonthlyPayBill;